export const screenshotResultsMock = {
  IDOrderID_Date_T_Time__3dModel: 'some model timestamp',
  IDOrderID_Date_T_Time__FULL_SCREEN: 'some screen timestamp',
  isNiriIndicationOn: false,
  IDOrderID_Date_T_Time__3dModel_MD5: 'some image hash',
  IDOrderID_Date_T_Time__FULL_SCREEN_MD5: 'some image hash',
};
